import { useEffect, useState } from "react";
import { Box, Skeleton, Typography } from "@mui/material";
import { useUsuario } from "../../../providers/usuarioProvider";
import Usuario from "../../../models/usuario";
import UsuarioDb from "../../../db/usuarioDb";
import { onSnapshot } from "firebase/firestore";
import { Perfil } from "../../../models/enum";
import FelixAvatar from "../../util/ui/felixAvatar";

export default function ContaBusiness() {
  const { visualizado, usuario } = useUsuario();
  const [cliente, setCliente] = useState<Usuario>();

  useEffect(() => {
    if (!!visualizado) {
      return onSnapshot(
        new UsuarioDb().doc({ usuarioId: visualizado }),
        (snapshot) => {
          setCliente(snapshot.data());
        }
      );
    }
  }, [visualizado]);

  if (!!!usuario?.business) return <></>;
  else
    return (
      <Box
        className="clienteSelecionado"
        display="flex"
        flexDirection="row"
        gap={2}
        alignItems="center"
      >
        <Box display="flex" flexDirection="column" alignItems="flex-end">
          <Typography
            variant="body2"
            color="text.primary"
            sx={{ fontWeight: 600, lineHeight: 1.2 }}
          >
            {!!cliente?.nome ? (
              cliente.nome
            ) : (
              <Skeleton variant="text" animation={false} width={80} />
            )}
          </Typography>
          {/* Id do cliente é código: mono tabular, em ink-60. */}
          <Typography
            variant="dataMono"
            color="text.secondary"
            sx={{ fontSize: 10, lineHeight: 1.4 }}
          >
            {!!cliente?.id ? (
              cliente.id
            ) : (
              <Skeleton variant="text" animation={false} width={120} />
            )}
          </Typography>
        </Box>
        <FelixAvatar
          nome={cliente?.nome ?? ""}
          size={36}
          perfil={Perfil.INVESTIDOR}
          fotoDePerfil={cliente?.fotoDePerfil}
        />
      </Box>
    );
}
